import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushGrabIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 16h20",
			opacity: .25
		}),
		/* @__PURE__ */ _jsx("path", { d: "M2 16c3 0 5-2 7-5s4-4 5-3" }),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 2.2,
			d: "m14 8 5-4"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M16 4h3.5v3.5" })
	]
});
export default SvgBrushGrabIcon;
